// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1CQ_B","textarea":"styles_textarea__1-ADL"};